import type { EnvironmentMessages } from '../types';

const messages: EnvironmentMessages = {
  'environment.manageModal.title': '环境管理',
  'environmentDetail.label.server': '服务（前置URL）',
  'environmentDetail.label.variables': '环境变量',
  'environment.title.variableName': '变量名',
  'environment.title.variableName.placeholder': '添加变量',
  'environment.title.addVariableValue': '添加变量',
  'environment.title.value': '变量值',
  'environment.title.serviceName': '服务名',
  variableNameEmptyError: '变量名不能为空!',
  preFixUrl: '前置 URL',
  'editor.tip': '数据格式遵循',
  filedBulkEdit: '批量编辑',
} as const;

export default messages;
